import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const showSubmenu = (elem, overlay) => {
  stopElemAnim(elem);
  stopElemAnim(overlay);

  showElem(elem);
  showElem(overlay);
};

const hideSubmenu = (elem, overlay) => {
  addCloseElemAnim(overlay);
  addCloseElemAnim(elem);

  timeout.id = setTimeout(() => {
    hideElem(elem);
    hideElem(overlay);
  }, 300);
};

export const initSubmenu = () => {
  const overlay = document.querySelector('.overlay');
  const submenuItems = document.querySelectorAll('.nav-submenu-item');

  submenuItems.forEach((submenuItem) => {
    const submenu = submenuItem.querySelector('.submenu');

    submenuItem.addEventListener('mouseenter', (e) => {
      submenuItem.classList.add('open');
      clearTimeout(timeout.id);
      showSubmenu(submenu, overlay);
    });
    submenuItem.addEventListener('mouseleave', (e) => {
      submenuItem.classList.remove('open');
      hideElem(e.target.querySelector('.submenu'));
      hideSubmenu(submenu, overlay);
    });
  });
};
